const CorrectScoresActionTypes = {
	GET_CORRECTSCORES_START: 'GET_CORRECTSCORES_START',
	GET_CORRECTSCORES_SUCCESS: 'GET_CORRECTSCORES_SUCCESS',
	GET_CORRECTSCORES_FAILURE: 'GET_CORRECTSCORES_FAILURE'
};

export default CorrectScoresActionTypes;
